import gql from 'graphql-tag';

export default {
  getMyCampaigns: gql`
    fragment EventLocation_getMyCampaigns on Campaign {
      eventLocation
    }
  `,
};
